"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Avatar", {
  enumerable: true,
  get: function get() {
    return _Avatar.Avatar;
  }
});
var _Avatar = require("./Avatar");
function cov_2pb11llli2() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Avatar/index.ts";
  var hash = "4053ff925499b77972372d320d45113fcd2c11ba";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Avatar/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4053ff925499b77972372d320d45113fcd2c11ba"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2pb11llli2 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2pb11llli2();